export const PaymentRequestObjectKeys: string[] = [
  'Payload',
  'StoreCard',
  'OrderNote',
  'RecurringPaymentConfirmation',
  'RecaptchaResponse',
  'IpAddress',
  'IsEmbeddedHostedPayment',
  'GivingPageContact',
  'GivingPageBillingAddress',
  'GivingPageDonation'
];